import type { AppRouter } from "@client/types";
import superjson from "superjson";
import { createTRPCClient, httpBatchLink, type TRPCLink, type TRPCClient } from "@trpc/client";
import { observable } from "@trpc/server/observable";
import { useUserStore } from "@client/stores";
import { BACKEND_PATH } from "@client/lib/globals";

export const $api: TRPCClient<AppRouter> = createTRPCClient<AppRouter>({
	links: [
		responseInterceptor(),
		httpBatchLink({
			transformer: superjson,
			url: `${BACKEND_PATH}/trpc`,
			fetch(url, options) {
				return fetch(url, {
					...options,
					credentials: "include",
				});
			},
		}),
	],
});

function responseInterceptor() {
	return (() => {
		return ({ next, op }) => {
			return observable((observer) => {
				return next(op).subscribe({
					next(value) {
						observer.next(value);
					},
					error(err) {
						const userStore = useUserStore();
						if (err?.data?.code === "UNAUTHORIZED") {
							userStore.clearCredentials();
							if (window.location.pathname !== "/") window.location.reload();
						}
						observer.error(err);
					},
					complete() {
						observer.complete();
					},
				});
			});
		};
	}) as TRPCLink<AppRouter>;
}
